import React        from "react";
import { Typography } from "@mui/material";
import { useTheme }   from "@mui/material/styles";

// Reusable PSI360 wordmark - used on login page and app bar
const WordMark = ({ size = "44px" }) => {
  const theme = useTheme();
  const t     = theme.custom;

  return (
    <Typography
      sx={{
        fontFamily:    "'Inter', sans-serif",
        fontSize:      size,
        fontWeight:    700,
        letterSpacing: "-0.01em",
        color:         t.text,
        lineHeight:    1,
      }}
    >
      Psi<span style={{ color: t.gold }}>360</span>
    </Typography>
  );
};

export default WordMark;